export const ELEMENT_SUCCESS_MESSAGE = 'ELEMENT_SUCCESS_MESSAGE';
export const ELEMENT_ERROR_MESSAGE = 'ELEMENT_ERROR_MESSAGE';
export const CONTENT_SEARCH_FILTER = 'CONTENT_SEARCH_FILTER';
export const CONTENT_DATA = 'CONTENT_DATA';
export const SEARCH_ENABLED = 'SEARCH_ENABLED';
export const VILLE_DATA = 'VILLE_DATA';
export const SEARCH_FORM_DATA = 'SEARCH_FORM_DATA';